export default __webpack_public_path__ + "static/media/devices_f_500.3b77d2bf.svg";